import React, { Fragment } from 'react';
import styled from 'styled-components';

import Admin from 'hive-admin';
import PageSingle from 'hive-admin/src/components/PageSingle';

import { Link } from 'react-router-dom';

import tests from '../../helpers/tests';

import {
  ADMIN as FIELDS_ADMIN,
  CREATE as FIELDS_CREATE,
  fieldChangeLog,
  fieldsDictionary,
} from './fields';

import {
  ADMIN as COLUMNS_ADMIN,
} from './columns';

import {
  ADMIN as FILTERS_ADMIN,
} from './filters';

class PageSingleLanguage extends PageSingle {
  renderHeaderDescription() {
    const description = this.props.renderHeaderDescription(this.props);
    if (!description) {
      return null;
    }
    return (
      <div
        key="page-header-description"
        className="page-header-description"
        style={{ zoom: 0.85 }}
      >
        {description}
      </div>
    );
  }
}

Admin.addToLibrary(
  'PageSingleLanguage',
  config => PageSingleLanguage.create(config)
);

const {
  viewerIsNotAdmin,
} = tests;

const PAGES = [
  {
    title: 'Config',
    path: 'config',
    fields: [
      ...FIELDS_ADMIN,
      // ...fieldChangeLog,
    ],
  },
  ...Object.keys(fieldsDictionary).map(key => ({
    title: `${key[0].toUpperCase()}${key.slice(1)}`,
    path: key,
    fields: [
      fieldsDictionary[key],
      ...fieldChangeLog,
    ],
  })),
];

const NavigationBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  &:last-child {
    margin-bottom: 16px;
  }
`;

const NavigationItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
`;

const NavigationItemHTML = ({ active, to, ...props }) => (
  active
    ? <span {...props} />
    : <Link to={to} {...props} />
);

const NavigationItem = styled(NavigationItemHTML)`
  &[data-navigation-item-size="large"] {
    font-size: 130%;
    color: ${props => (
      props.active
        ? props.theme.less.primaryColor
        : props.theme.less.textColor
    )};
    text-decoration: ${props => (props.active ? 'underline' : 'none')};
    &:hover {
      color: ${props => props.theme.less.primaryColor};
    }
  }
`;

const NavigationItemSeparator = styled.div`
  padding: 0px 10px;
  display: flex;
  transform: translateY(-1px);
  flex-shrink: 0;
  opacity: 0.4;
`;

const renderHeaderDescription = props => (
  props.data
    ? (
      <Fragment key="header-description">
        <NavigationBlock style={{ marginTop: '20px' }}>
          {
            PAGES
              .filter(({ skipHeaderItem, getSkipHeaderItem }) => (
                !skipHeaderItem
                && (
                  !getSkipHeaderItem
                  || !getSkipHeaderItem(props)
                )
              ))
              .reduce(
                (agr, { title, path }, i, array) => {
                  agr.push(
                    <NavigationItemWrapper key={title}>
                      <NavigationItem
                        data-navigation-item-size="large"
                        active={path === props.id}
                        key={title}
                        to={path}
                      >
                        {title}
                      </NavigationItem>
                      {
                        i < array.length - 1
                          ? (
                            <NavigationItemSeparator key={`${title}-sep`}>
                              |
                            </NavigationItemSeparator>
                          )
                          : null
                      }
                    </NavigationItemWrapper>
                  );
                  return agr;
                },
                [],
              )
          }
        </NavigationBlock>
      </Fragment>
    )
    : null
);

const {
  adminPages,
} = PAGES.reduce(
  (
    agr,
    {
      title,
      path,
      fields,
      config = {},
      adminConfig = {},
    },
  ) => {
    agr.adminPages.push(Admin.compileFromLibrary(['PageSingleLanguage', {
      ...agr.defaultConfig,
      ...agr.defaultAdminConfig,
      id: path,
      path: `/languages/:id/${path}`,
      title: `${title}`,
      fields,
      ...config,
      ...adminConfig,
    }]));
    return agr;
  },
  {
    adminPages: [],
    defaultConfig: {
      exact: true,
      useTrash: false,
      activity: 'edit',
      saveMethod: 'patch',
      notFoundMessage: 'Client not found!',
      loadExtractData: response => (response ? response.data : null),
      renderHeaderDescription,
      actions: [
        Admin.compileFromLibrary(['ActionSaveAndReload']),
      ],
    },
    defaultAdminConfig: {
      loadUrl: '/languages/:id',
      saveUrl: '/languages/:id/?front=true',
      deleteUrl: '/languages/:id',
      alias: '/languages',
      hidden: true,
      redirect: [
        Admin.compileFromLibrary(['redirect.unauthorized']),
        Admin.compileFromLibrary([
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/orders',
        ]),
      ],
      actions: [
        Admin.compileFromLibrary(['ActionSaveAndReload']),
      ],
    },
  },
);

export default [
  ...adminPages,
  ...Admin.compileFromLibrary(['GroupResource', {
    title: 'Languages',
    path: '/languages',
    // icon: 'global',
    redirect: [
      ['redirect.unauthorized'],
      [
        'redirect.checkViewer',
        'role', '!==', 'ADMIN',
        '/store',
      ],
    ],
    filters: FILTERS_ADMIN,
    columns: COLUMNS_ADMIN,
    archiveConfig: {
      title: 'Languages',
      label: 'Languages',
      // icon: 'global',
      loadUrl: '/languages',
      createButtonPath: '/languages/create',
      hidden: [viewerIsNotAdmin],
    },
    singleConfig: {
      hidden: true,
      alias: '/languages',
      headerTitle: 'Create Language',
      backButtonPaths: ['/languages'],
    },
    singleCreateConfig: {
      fields: FIELDS_CREATE,
      createRedirectPath: '/languages/:_id/config',
    },
    singleEditConfig: {
      fields: [],
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/orders',
        ],
      ],
    },
  }]).pages,
];
